import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import HorizontalSplitIcon from "@material-ui/icons/HorizontalSplit";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import Chip from "@material-ui/core/Chip";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputAdornment from "@material-ui/core/InputAdornment";
import { createTheme, makeStyles } from "@material-ui/core/styles";
import Cookies from "js-cookie";
import clsx from "clsx";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
const _ = require("lodash");
const axios = require("axios");
function valuetext(value) {
  return `${value}°C`;
}

export default function FormDialog({
  setTokenStillValid,
  classes,
  MenuProps,
  getStyles,
  theme,
  currentOrganisation,
  dataType,
  tSStart,
  tSEnd,
  tSClearStart,
  tSClearEnd,
  EquipmentIDs,
  equipmentIDs,
  equipmentGroup,
  alarmTypes,
  alarmList,
  temperature,
  withinOrExceed,
  durationDays,
  durationHours,
  durationMinutes,
  weightDischarged,
  balancedWeight,
  weightLimit,
  handleClear,
  filledLevelPercent,
  handleTimeStampStart,
  handleTimeStampEnd,
  handleClearTimeStampStart,
  handleClearTimeStampEnd,
  handleMultipleEquipmentID,
  handleEquipmentGroups,
  handleMultipleAlarmTypes,
  handleWithinOrExceed,
  handleSetDurationDays,
  handleSetDurationHours,
  handleSetDurationMinutes,
  handleDischargeWeight,
  handleBalanceWeight,
  handleDischargeWeightLimit,
  handleBalanceWeightLimit,
  handleFilledLevelPercent,
  handleTemperatureLimit,
  handleTemperature,
  handleFilledLevelLimit,
  handleDropDownClose,
}) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = async () => {
    let authObj = Cookies.get("authObj");
    let token;
    if (authObj) {
      authObj = JSON.parse(authObj);
      token = authObj["token"];
    }
    let apiKeys = {
      admin: "jnjirej9reinvuiriuerhuinui",
      serviceUser: "juit959fjji44jcion4moij0kc",
    };

    let config = {
      headers: { Authorization: `Bearer ${token}`, apikey: apiKeys["admin"] },
    };

    let checkExpiry = await axios.post(
      `${process.env.REACT_APP_API}/checkTokenExpiry`,
      {},
      config
    );
    checkExpiry = checkExpiry.data;
    let { success } = checkExpiry;
    if (!success) {
      setTokenStillValid(false);
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const useStyles = makeStyles(() => ({
    paper: { minWidth: "500px" },
  }));

  let body = (
    <Dialog
      fullWidth
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">
        Advance Filtering Options
      </DialogTitle>
      <DialogContent>
        <DialogContentText>Feature still in Development</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );

  switch (currentOrganisation) {
    case "sembwaste":
      if (dataType === "Alarm") {
        body = (
          <Dialog
            fullWidth
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">
              Advance Filtering Options
            </DialogTitle>

            <DialogContent>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Alarm Trigger TimeStamp
                  </span>
                </Grid>
              </Grid>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justifyContent="space-around">
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="Start Date"
                    value={tSStart}
                    onChange={handleTimeStampStart}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSStart > tSEnd ? true : false}
                    helperText={
                      tSStart > tSEnd
                        ? "Start Date should not be later than End Date"
                        : null
                    }
                  />
                  &nbsp;&nbsp;&nbsp;
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="End Date"
                    value={tSEnd}
                    onChange={handleTimeStampEnd}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSStart > tSEnd ? true : false}
                    helperText={
                      tSStart > tSEnd
                        ? "End Date should not be earlier than Start Date"
                        : null
                    }
                  />
                </Grid>
                <div>&nbsp;</div>
              </MuiPickersUtilsProvider>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Alarm Clear TimeStamp
                  </span>
                </Grid>
              </Grid>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justifyContent="space-around">
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="Start Date"
                    value={tSClearStart}
                    onChange={handleClearTimeStampStart}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSClearStart > tSClearEnd ? true : false}
                    helperText={
                      tSClearStart > tSClearEnd
                        ? "Start Date should not be later than End Date"
                        : null
                    }
                  />
                  &nbsp;&nbsp;&nbsp;
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="End Date"
                    value={tSClearEnd}
                    onChange={handleClearTimeStampEnd}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSClearStart > tSClearEnd ? true : false}
                    helperText={
                      tSClearStart > tSClearEnd
                        ? "End Date should not be earlier than Start Date"
                        : null
                    }
                  />
                </Grid>
                <div>&nbsp;</div>
              </MuiPickersUtilsProvider>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Duration for Alarm Deactivation
                  </span>
                </Grid>
              </Grid>
              <div>&nbsp;</div>

              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Clear duration is
                  </span>
                  &nbsp;&nbsp;&nbsp;
                  <FormControl className={classes.formControl}>
                    {/* <InputLabel id='demo-simple-select-label'>Age</InputLabel> */}
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={withinOrExceed}
                      onChange={handleWithinOrExceed}
                    >
                      <MenuItem value={"Within"}>Within</MenuItem>
                      <MenuItem value={"Exceed"}>Exceed</MenuItem>
                    </Select>
                  </FormControl>
                  &nbsp; &nbsp; &nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "10ch" }}
                    onChange={handleSetDurationDays}
                    value={durationDays}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">Day</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                  &nbsp; &nbsp; &nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "10ch" }}
                    onChange={handleSetDurationHours}
                    value={durationHours}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      inputProps: {
                        max: 24,
                        min: -1,
                      },
                      endAdornment: (
                        <InputAdornment position="start">Hrs</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                  &nbsp; &nbsp; &nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "10ch" }}
                    onChange={handleSetDurationMinutes}
                    value={durationMinutes}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      inputProps: {
                        max: 60,
                        min: -1,
                      },
                      endAdornment: (
                        <InputAdornment position="start">Min</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Equipment Groups
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl style={{ minWidth: 180 }}>
                    <InputLabel id="demo-simple-select-label">
                      Equipment Groups
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={equipmentGroup}
                      onChange={handleEquipmentGroups}
                    >
                      <MenuItem value={null}>None</MenuItem>
                      <MenuItem value={"DS"}>DS</MenuItem>
                      <MenuItem value={"MM"}>MM</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Equipment ID
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl
                    style={{ minWidth: 120 }}
                    className={classes.formControl}
                  >
                    <InputLabel id="demo-mutiple-chip-label">
                      Equipment ID
                    </InputLabel>
                    <Select
                      labelId="demo-mutiple-chip-label"
                      id="demo-mutiple-chip"
                      multiple
                      value={EquipmentIDs}
                      onChange={handleMultipleEquipmentID}
                      input={<Input id="select-multiple-chip" />}
                      renderValue={(selected) => (
                        <div>
                          {selected.map((value) => (
                            <Chip key={value} label={value} />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                    >
                      {equipmentIDs.map((ids) => (
                        <MenuItem
                          key={ids}
                          value={ids}
                          style={getStyles(ids, EquipmentIDs, theme)}
                        >
                          {ids}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Alarm Types
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl
                    style={{ minWidth: 120 }}
                    className={classes.formControl}
                  >
                    <InputLabel id="demo-mutiple-chip-label">
                      Alarm Types
                    </InputLabel>
                    <Select
                      labelId="demo-mutiple-chip-label"
                      id="demo-mutiple-chip"
                      multiple
                      value={alarmTypes}
                      onChange={handleMultipleAlarmTypes}
                      input={<Input id="select-multiple-chip" />}
                      renderValue={(selected) => (
                        <div>
                          {selected.map((value) => (
                            <Chip key={value} label={value} />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                    >
                      {alarmList.map((alarms) => (
                        <MenuItem
                          key={alarms}
                          value={alarms}
                          style={getStyles(alarms, alarmTypes, theme)}
                        >
                          {alarms}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Apply
              </Button>
              <Button onClick={handleClear} color="primary">
                Clear
              </Button>
            </DialogActions>
          </Dialog>
        );
      }

      if (dataType === "Weight") {
        body = (
          <Dialog
            fullWidth
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">
              Advance Filtering Options
            </DialogTitle>

            <DialogContent>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Weight Discharge Time
                  </span>
                </Grid>
              </Grid>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justifyContent="space-around">
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="Start Date"
                    value={tSStart}
                    onChange={handleTimeStampStart}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSStart > tSEnd ? true : false}
                    helperText={
                      tSStart > tSEnd
                        ? "Start Date should not be later than End Date"
                        : null
                    }
                  />
                  &nbsp;&nbsp;&nbsp;
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="End Date"
                    value={tSEnd}
                    onChange={handleTimeStampEnd}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSStart > tSEnd ? true : false}
                    helperText={
                      tSStart > tSEnd
                        ? "End Date should not be earlier than Start Date"
                        : null
                    }
                  />
                </Grid>
                <div>&nbsp;</div>
              </MuiPickersUtilsProvider>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Equipment Groups
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl style={{ minWidth: 180 }}>
                    <InputLabel id="demo-simple-select-label">
                      Equipment Groups
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={equipmentGroup}
                      onChange={handleEquipmentGroups}
                    >
                      <MenuItem value={null}>None</MenuItem>
                      <MenuItem value={"DS"}>DS</MenuItem>
                      <MenuItem value={"MM"}>MM</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Equipment ID
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl
                    style={{ minWidth: 120 }}
                    className={classes.formControl}
                  >
                    <InputLabel id="demo-mutiple-chip-label">
                      Equipment ID
                    </InputLabel>
                    <Select
                      labelId="demo-mutiple-chip-label"
                      id="demo-mutiple-chip"
                      multiple
                      value={EquipmentIDs}
                      onChange={handleMultipleEquipmentID}
                      input={<Input id="select-multiple-chip" />}
                      renderValue={(selected) => (
                        <div>
                          {selected.map((value) => (
                            <Chip key={value} label={value} />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                    >
                      {equipmentIDs.map((ids) => (
                        <MenuItem
                          key={ids}
                          value={ids}
                          style={getStyles(ids, EquipmentIDs, theme)}
                        >
                          {ids}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <div>&nbsp;</div>

              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Discharge Weight
                  </span>
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", marginTop: "0.4em" }}>
                    Discharge Weight is
                  </span>
                  &nbsp;&nbsp; &nbsp;&nbsp;
                  <FormControl className={classes.formControl}>
                    {/* <InputLabel id='demo-simple-select-label'>Age</InputLabel> */}
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={weightLimit.discharge}
                      onChange={handleDischargeWeightLimit}
                    >
                      <MenuItem value={"="}>{"equals"}</MenuItem>
                      <MenuItem value={"!="}>{"not equals"}</MenuItem>
                      <MenuItem value={">"}>{"more than"}</MenuItem>
                      <MenuItem value={">="}>
                        {"more than or equals to"}
                      </MenuItem>
                      <MenuItem value={"<"}>{"less than"}</MenuItem>
                      <MenuItem value={"<="}>{"less than or equals"}</MenuItem>
                    </Select>
                  </FormControl>
                  &nbsp;&nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "12ch" }}
                    onChange={handleDischargeWeight}
                    value={weightDischarged}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">Kg</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", marginTop: "0.4em" }}>
                    Balanced Weight is
                  </span>
                  &nbsp;&nbsp; &nbsp;&nbsp;
                  <FormControl className={classes.formControl}>
                    {/* <InputLabel id='demo-simple-select-label'>Age</InputLabel> */}
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={weightLimit.balance}
                      onChange={handleBalanceWeightLimit}
                    >
                      <MenuItem value={"="}>{"equals"}</MenuItem>
                      <MenuItem value={"!="}>{"not equals"}</MenuItem>
                      <MenuItem value={">"}>{"more than"}</MenuItem>
                      <MenuItem value={">="}>
                        {"more than or equals to"}
                      </MenuItem>
                      <MenuItem value={"<"}>{"less than"}</MenuItem>
                      <MenuItem value={"<="}>{"less than or equals"}</MenuItem>
                    </Select>
                  </FormControl>
                  &nbsp;&nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "12ch" }}
                    onChange={handleBalanceWeight}
                    value={balancedWeight}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">Kg</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Apply
              </Button>
              <Button onClick={handleClear} color="primary">
                Clear
              </Button>
            </DialogActions>
          </Dialog>
        );
      }
      break;
    case "ntu":
      if (dataType === "Alarm") {
        let arr = [];
        for (let i = 0; i < 8; i++) {
          arr.push(i);
        }

        arr = [];
        for (let i = 0; i < 24; i++) {
          arr.push(i);
        }
        arr = [];
        for (let i = 0; i < 60; i++) {
          arr.push(i);
        }

        body = (
          <Dialog
            fullWidth
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">
              Advance Filtering Options
            </DialogTitle>

            <DialogContent>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Alarm Trigger TimeStamp
                  </span>
                </Grid>
              </Grid>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justifyContent="space-around">
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="Start Date"
                    value={tSStart}
                    onChange={handleTimeStampStart}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSStart > tSEnd ? true : false}
                    helperText={
                      tSStart > tSEnd
                        ? "Start Date should not be later than End Date"
                        : null
                    }
                  />
                  &nbsp;&nbsp;&nbsp;
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="End Date"
                    value={tSEnd}
                    onChange={handleTimeStampEnd}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSStart > tSEnd ? true : false}
                    helperText={
                      tSStart > tSEnd
                        ? "End Date should not be earlier than Start Date"
                        : null
                    }
                  />
                </Grid>
                <div>&nbsp;</div>
              </MuiPickersUtilsProvider>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Alarm Clear TimeStamp
                  </span>
                </Grid>
              </Grid>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justifyContent="space-around">
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="Start Date"
                    value={tSClearStart}
                    onChange={handleClearTimeStampStart}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSClearStart > tSClearEnd ? true : false}
                    helperText={
                      tSClearStart > tSClearEnd
                        ? "Start Date should not be later than End Date"
                        : null
                    }
                  />
                  &nbsp;&nbsp;&nbsp;
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="End Date"
                    value={tSClearEnd}
                    onChange={handleClearTimeStampEnd}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSClearStart > tSClearEnd ? true : false}
                    helperText={
                      tSClearStart > tSClearEnd
                        ? "End Date should not be earlier than Start Date"
                        : null
                    }
                  />
                </Grid>
                <div>&nbsp;</div>
              </MuiPickersUtilsProvider>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Duration for Alarm Deactivation
                  </span>
                </Grid>
              </Grid>
              <div>&nbsp;</div>

              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em" }}>Clear duration is</span>
                  &nbsp;&nbsp;&nbsp;
                  <FormControl className={classes.formControl}>
                    {/* <InputLabel id='demo-simple-select-label'>Age</InputLabel> */}
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={withinOrExceed}
                      onChange={handleWithinOrExceed}
                    >
                      <MenuItem value={"Within"}>Within</MenuItem>
                      <MenuItem value={"Exceed"}>Exceed</MenuItem>
                    </Select>
                  </FormControl>
                  &nbsp; &nbsp; &nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "10ch" }}
                    onChange={handleSetDurationDays}
                    value={durationDays}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">Day</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                  &nbsp; &nbsp; &nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "10ch" }}
                    onChange={handleSetDurationHours}
                    value={durationHours}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      inputProps: {
                        max: 24,
                        min: -1,
                      },
                      endAdornment: (
                        <InputAdornment position="start">Hrs</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                  &nbsp; &nbsp; &nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "10ch" }}
                    onChange={handleSetDurationMinutes}
                    value={durationMinutes}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      inputProps: {
                        max: 60,
                        min: -1,
                      },
                      endAdornment: (
                        <InputAdornment position="start">Min</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Equipment Groups
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl style={{ minWidth: 180 }}>
                    <InputLabel id="demo-simple-select-label">
                      Equipment Groups
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={equipmentGroup}
                      onChange={handleEquipmentGroups}
                    >
                      <MenuItem value={null}>None</MenuItem>
                      <MenuItem value={"CP"}>CP</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Equipment ID
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl
                    style={{ minWidth: 120 }}
                    className={classes.formControl}
                  >
                    <InputLabel id="demo-mutiple-chip-label">
                      Equipment ID
                    </InputLabel>
                    <Select
                      labelId="demo-mutiple-chip-label"
                      id="demo-mutiple-chip"
                      multiple
                      value={EquipmentIDs}
                      onChange={handleMultipleEquipmentID}
                      input={<Input id="select-multiple-chip" />}
                      renderValue={(selected) => (
                        <div>
                          {selected.map((value) => (
                            <Chip key={value} label={value} />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                    >
                      {equipmentIDs.map((ids) => (
                        <MenuItem
                          key={ids}
                          value={ids}
                          style={getStyles(ids, EquipmentIDs, theme)}
                        >
                          {ids}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Alarm Types
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl
                    style={{ minWidth: 120 }}
                    className={classes.formControl}
                  >
                    <InputLabel id="demo-mutiple-chip-label">
                      Alarm Types
                    </InputLabel>
                    <Select
                      labelId="demo-mutiple-chip-label"
                      id="demo-mutiple-chip"
                      multiple
                      value={alarmTypes}
                      onChange={handleMultipleAlarmTypes}
                      input={<Input id="select-multiple-chip" />}
                      renderValue={(selected) => (
                        <div>
                          {selected.map((value) => (
                            <Chip key={value} label={value} />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                    >
                      {alarmList.map((alarms) => (
                        <MenuItem
                          key={alarms}
                          value={alarms}
                          style={getStyles(alarms, alarmTypes, theme)}
                        >
                          {alarms}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Apply
              </Button>
              <Button onClick={handleClear} color="primary">
                Clear
              </Button>
            </DialogActions>
          </Dialog>
        );
      }

      if (dataType === "Other") {
        body = (
          <Dialog
            fullWidth
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">
              Advance Filtering Options
            </DialogTitle>

            <DialogContent>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    TimeStamp
                  </span>
                </Grid>
              </Grid>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justifyContent="space-around">
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="Start Date"
                    value={tSStart}
                    onChange={handleTimeStampStart}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSStart > tSEnd ? true : false}
                    helperText={
                      tSStart > tSEnd
                        ? "Start Date should not be later than End Date"
                        : null
                    }
                  />
                  &nbsp;&nbsp;&nbsp;
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="End Date"
                    value={tSEnd}
                    onChange={handleTimeStampEnd}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSStart > tSEnd ? true : false}
                    helperText={
                      tSStart > tSEnd
                        ? "End Date should not be earlier than Start Date"
                        : null
                    }
                  />
                </Grid>
              </MuiPickersUtilsProvider>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Equipment Groups
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl style={{ minWidth: 180 }}>
                    <InputLabel id="demo-simple-select-label">
                      Equipment Groups
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={equipmentGroup}
                      onChange={handleEquipmentGroups}
                    >
                      <MenuItem value={null}>None</MenuItem>
                      <MenuItem value={"CP"}>CP</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Equipment ID
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl
                    style={{ minWidth: 120 }}
                    className={classes.formControl}
                  >
                    <InputLabel id="demo-mutiple-chip-label">
                      Equipment ID
                    </InputLabel>
                    <Select
                      labelId="demo-mutiple-chip-label"
                      id="demo-mutiple-chip"
                      multiple
                      value={EquipmentIDs}
                      onChange={handleMultipleEquipmentID}
                      input={<Input id="select-multiple-chip" />}
                      renderValue={(selected) => (
                        <div>
                          {selected.map((value) => (
                            <Chip key={value} label={value} />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                    >
                      {equipmentIDs.map((ids) => (
                        <MenuItem
                          key={ids}
                          value={ids}
                          style={getStyles(ids, EquipmentIDs, theme)}
                        >
                          {ids}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Temperature
                  </span>
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", marginTop: "0.3em" }}>
                    Temperature is
                  </span>
                  &nbsp;&nbsp;
                  <FormControl className={classes.formControl}>
                    {/* <InputLabel id='demo-simple-select-label'>Age</InputLabel> */}
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={weightLimit.temperature}
                      onChange={handleTemperatureLimit}
                    >
                      <MenuItem value={"="}>{"equals"}</MenuItem>
                      <MenuItem value={"!="}>{"not equals"}</MenuItem>
                      <MenuItem value={">"}>{"exceeds"}</MenuItem>
                      <MenuItem value={">="}>{"exceeds and equals"}</MenuItem>
                      <MenuItem value={"<"}>{"less than"}</MenuItem>
                      <MenuItem value={"<="}>{"less than or equals"}</MenuItem>
                    </Select>
                  </FormControl>
                  &nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "10ch" }}
                    onChange={handleTemperature}
                    value={temperature}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">°C</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", marginTop: "0.3em" }}>
                    Filled Level is
                  </span>
                  &nbsp;&nbsp;
                  <FormControl className={classes.formControl}>
                    {/* <InputLabel id='demo-simple-select-label'>Age</InputLabel> */}
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={weightLimit.filledPercent}
                      onChange={handleFilledLevelLimit}
                    >
                      <MenuItem value={"="}>{"equals"}</MenuItem>
                      <MenuItem value={"!="}>{"not equals"}</MenuItem>
                      <MenuItem value={">"}>{"exceeds"}</MenuItem>
                      <MenuItem value={">="}>{"exceeds and equals"}</MenuItem>
                      <MenuItem value={"<"}>{"less than"}</MenuItem>
                      <MenuItem value={"<="}>{"less than or equals"}</MenuItem>
                    </Select>
                  </FormControl>
                  &nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "10ch" }}
                    onChange={handleFilledLevelPercent}
                    value={filledLevelPercent}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">%</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Apply
              </Button>
              <Button onClick={handleClear} color="primary">
                Clear
              </Button>
            </DialogActions>
          </Dialog>
        );
      }
      break;
    case "800_SGbins":
      if (dataType === "Alarm") {
        let arr = [];
        for (let i = 0; i < 8; i++) {
          arr.push(i);
        }

        arr = [];
        for (let i = 0; i < 24; i++) {
          arr.push(i);
        }
        arr = [];
        for (let i = 0; i < 60; i++) {
          arr.push(i);
        }

        body = (
          <Dialog
            fullWidth
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">
              Advance Filtering Options
            </DialogTitle>

            <DialogContent>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Alarm Trigger TimeStamp
                  </span>
                </Grid>
              </Grid>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justifyContent="space-around">
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="Start Date"
                    value={tSStart}
                    onChange={handleTimeStampStart}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSStart > tSEnd ? true : false}
                    helperText={
                      tSStart > tSEnd
                        ? "Start Date should not be later than End Date"
                        : null
                    }
                  />
                  &nbsp;&nbsp;&nbsp;
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="End Date"
                    value={tSEnd}
                    onChange={handleTimeStampEnd}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSStart > tSEnd ? true : false}
                    helperText={
                      tSStart > tSEnd
                        ? "End Date should not be earlier than Start Date"
                        : null
                    }
                  />
                </Grid>
                <div>&nbsp;</div>
              </MuiPickersUtilsProvider>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Alarm Clear TimeStamp
                  </span>
                </Grid>
              </Grid>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justifyContent="space-around">
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="Start Date"
                    value={tSClearStart}
                    onChange={handleClearTimeStampStart}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSClearStart > tSClearEnd ? true : false}
                    helperText={
                      tSClearStart > tSClearEnd
                        ? "Start Date should not be later than End Date"
                        : null
                    }
                  />
                  &nbsp;&nbsp;&nbsp;
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="End Date"
                    value={tSClearEnd}
                    onChange={handleClearTimeStampEnd}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSClearStart > tSClearEnd ? true : false}
                    helperText={
                      tSClearStart > tSClearEnd
                        ? "End Date should not be earlier than Start Date"
                        : null
                    }
                  />
                </Grid>
                <div>&nbsp;</div>
              </MuiPickersUtilsProvider>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Duration for Alarm Deactivation
                  </span>
                </Grid>
              </Grid>
              <div>&nbsp;</div>

              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em" }}>Clear duration is</span>
                  &nbsp;&nbsp;&nbsp;
                  <FormControl className={classes.formControl}>
                    {/* <InputLabel id='demo-simple-select-label'>Age</InputLabel> */}
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={withinOrExceed}
                      onChange={handleWithinOrExceed}
                    >
                      <MenuItem value={"Within"}>Within</MenuItem>
                      <MenuItem value={"Exceed"}>Exceed</MenuItem>
                    </Select>
                  </FormControl>
                  &nbsp; &nbsp; &nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "10ch" }}
                    onChange={handleSetDurationDays}
                    value={durationDays}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">Day</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                  &nbsp; &nbsp; &nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "10ch" }}
                    onChange={handleSetDurationHours}
                    value={durationHours}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      inputProps: {
                        max: 24,
                        min: -1,
                      },
                      endAdornment: (
                        <InputAdornment position="start">Hrs</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                  &nbsp; &nbsp; &nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "10ch" }}
                    onChange={handleSetDurationMinutes}
                    value={durationMinutes}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      inputProps: {
                        max: 60,
                        min: -1,
                      },
                      endAdornment: (
                        <InputAdornment position="start">Min</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Equipment Groups
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl style={{ minWidth: 180 }}>
                    <InputLabel id="demo-simple-select-label">
                      Equipment Area
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={equipmentGroup}
                      onChange={handleEquipmentGroups}
                    >
                      <MenuItem value={null}>None</MenuItem>
                      <MenuItem value={"IZSGB-AMK"}>Ang Mo Kio</MenuItem>
                      <MenuItem value={"IZSGB-B"}>Bishan</MenuItem>
                      <MenuItem value={"IZSGB-BHD"}>Bright Hill</MenuItem>
                      <MenuItem value={"IZSGB-KKA"}>Kim Keat Ave</MenuItem>
                      <MenuItem value={"IZSGB-KKL"}>Kim Keat Link</MenuItem>
                      <MenuItem value={"IZSGB-PP"}>Potong Pasir</MenuItem>
                      <MenuItem value={"IZSGB-SA"}>Serangoon Ave</MenuItem>
                      <MenuItem value={"IZSGB-SC"}>Serangoon Central</MenuItem>
                      <MenuItem value={"IZSGB-SN"}>Serangoon North</MenuItem>
                      <MenuItem value={"IZSGB-SM"}>Sim Ming</MenuItem>
                      <MenuItem value={"IZSGB-TPY"}>Toa Payoh</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Equipment ID
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl
                    style={{ minWidth: 120 }}
                    className={classes.formControl}
                  >
                    <InputLabel id="demo-mutiple-chip-label">
                      Equipment ID
                    </InputLabel>
                    <Select
                      labelId="demo-mutiple-chip-label"
                      id="demo-mutiple-chip"
                      multiple
                      value={EquipmentIDs}
                      onChange={handleMultipleEquipmentID}
                      input={<Input id="select-multiple-chip" />}
                      renderValue={(selected) => (
                        <div>
                          {selected.map((value) => (
                            <Chip key={value} label={value} />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                    >
                      {equipmentIDs.map((ids) => (
                        <MenuItem
                          key={ids}
                          value={ids}
                          style={getStyles(ids, EquipmentIDs, theme)}
                        >
                          {ids}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Alarm Types
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl
                    style={{ minWidth: 120 }}
                    className={classes.formControl}
                  >
                    <InputLabel id="demo-mutiple-chip-label">
                      Alarm Types
                    </InputLabel>
                    <Select
                      labelId="demo-mutiple-chip-label"
                      id="demo-mutiple-chip"
                      multiple
                      value={alarmTypes}
                      onChange={handleMultipleAlarmTypes}
                      input={<Input id="select-multiple-chip" />}
                      renderValue={(selected) => (
                        <div>
                          {selected.map((value) => (
                            <Chip key={value} label={value} />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                    >
                      {alarmList.map((alarms) => (
                        <MenuItem
                          key={alarms}
                          value={alarms}
                          style={getStyles(alarms, alarmTypes, theme)}
                        >
                          {alarms}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Apply
              </Button>
              <Button onClick={handleClear} color="primary">
                Clear
              </Button>
            </DialogActions>
          </Dialog>
        );
      }

      if (dataType === "Other") {
        body = (
          <Dialog
            fullWidth
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">
              Advance Filtering Options
            </DialogTitle>

            <DialogContent>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    TimeStamp
                  </span>
                </Grid>
              </Grid>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justifyContent="space-around">
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="Start Date"
                    value={tSStart}
                    onChange={handleTimeStampStart}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSStart > tSEnd ? true : false}
                    helperText={
                      tSStart > tSEnd
                        ? "Start Date should not be later than End Date"
                        : null
                    }
                  />
                  &nbsp;&nbsp;&nbsp;
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="End Date"
                    value={tSEnd}
                    onChange={handleTimeStampEnd}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSStart > tSEnd ? true : false}
                    helperText={
                      tSStart > tSEnd
                        ? "End Date should not be earlier than Start Date"
                        : null
                    }
                  />
                </Grid>
              </MuiPickersUtilsProvider>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Equipment Area
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl style={{ minWidth: 180 }}>
                    <InputLabel id="demo-simple-select-label">
                      Equipment Area
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={equipmentGroup}
                      onChange={handleEquipmentGroups}
                    >
                      <MenuItem value={null}>None</MenuItem>
                      <MenuItem value={"IZSGB-AMK"}>Ang Mo Kio</MenuItem>
                      <MenuItem value={"IZSGB-B"}>Bishan</MenuItem>
                      <MenuItem value={"IZSGB-BHD"}>Bright Hill</MenuItem>
                      <MenuItem value={"IZSGB-KKA"}>Kim Keat Ave</MenuItem>
                      <MenuItem value={"IZSGB-KKL"}>Kim Keat Link</MenuItem>
                      <MenuItem value={"IZSGB-PP"}>Potong Pasir</MenuItem>
                      <MenuItem value={"IZSGB-SA"}>Serangoon Ave</MenuItem>
                      <MenuItem value={"IZSGB-SC"}>Serangoon Central</MenuItem>
                      <MenuItem value={"IZSGB-SN"}>Serangoon North</MenuItem>
                      <MenuItem value={"IZSGB-SM"}>Sim Ming</MenuItem>
                      <MenuItem value={"IZSGB-TPY"}>Toa Payoh</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Equipment ID
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl
                    style={{ minWidth: 120 }}
                    className={classes.formControl}
                  >
                    <InputLabel id="demo-mutiple-chip-label">
                      Equipment ID
                    </InputLabel>
                    <Select
                      labelId="demo-mutiple-chip-label"
                      id="demo-mutiple-chip"
                      multiple
                      value={EquipmentIDs}
                      onChange={handleMultipleEquipmentID}
                      input={<Input id="select-multiple-chip" />}
                      renderValue={(selected) => (
                        <div>
                          {selected.map((value) => (
                            <Chip key={value} label={value} />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                    >
                      {equipmentIDs.map((ids) => (
                        <MenuItem
                          key={ids}
                          value={ids}
                          style={getStyles(ids, EquipmentIDs, theme)}
                        >
                          {ids}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Weight
                  </span>
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", marginTop: "0.4em" }}>
                    Weight is
                  </span>
                  &nbsp;&nbsp; &nbsp;&nbsp;
                  <FormControl className={classes.formControl}>
                    {/* <InputLabel id='demo-simple-select-label'>Age</InputLabel> */}
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={weightLimit.balance}
                      onChange={handleBalanceWeightLimit}
                    >
                      <MenuItem value={"="}>{"equals"}</MenuItem>
                      <MenuItem value={"!="}>{"not equals"}</MenuItem>
                      <MenuItem value={">"}>{"exceeds"}</MenuItem>
                      <MenuItem value={">="}>{"exceeds and equals"}</MenuItem>
                      <MenuItem value={"<"}>{"less than"}</MenuItem>
                      <MenuItem value={"<="}>{"less than or equals"}</MenuItem>
                    </Select>
                  </FormControl>
                  &nbsp;&nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "12ch" }}
                    onChange={handleBalanceWeight}
                    value={balancedWeight}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">Kg</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", marginTop: "0.3em" }}>
                    Filled Level is
                  </span>
                  &nbsp;&nbsp;
                  <FormControl className={classes.formControl}>
                    {/* <InputLabel id='demo-simple-select-label'>Age</InputLabel> */}
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={weightLimit.filledPercent}
                      onChange={handleFilledLevelLimit}
                    >
                      <MenuItem value={"="}>{"equals"}</MenuItem>
                      <MenuItem value={"!="}>{"not equals"}</MenuItem>
                      <MenuItem value={">"}>{"exceeds"}</MenuItem>
                      <MenuItem value={">="}>{"exceeds and equals"}</MenuItem>
                      <MenuItem value={"<"}>{"less than"}</MenuItem>
                      <MenuItem value={"<="}>{"less than or equals"}</MenuItem>
                    </Select>
                  </FormControl>
                  &nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "10ch" }}
                    onChange={handleFilledLevelPercent}
                    value={filledLevelPercent}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">%</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Apply
              </Button>
              <Button onClick={handleClear} color="primary">
                Clear
              </Button>
            </DialogActions>
          </Dialog>
        );
      }
      break;
    case "ntuGomic":
      if (dataType === "Alarm") {
        let arr = [];
        for (let i = 0; i < 8; i++) {
          arr.push(i);
        }

        arr = [];
        for (let i = 0; i < 24; i++) {
          arr.push(i);
        }
        arr = [];
        for (let i = 0; i < 60; i++) {
          arr.push(i);
        }

        body = (
          <Dialog
            fullWidth
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">
              Advance Filtering Options
            </DialogTitle>

            <DialogContent>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Alarm Trigger TimeStamp
                  </span>
                </Grid>
              </Grid>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justifyContent="space-around">
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="dd/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="Start Date"
                    value={tSStart}
                    onChange={handleTimeStampStart}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSStart > tSEnd ? true : false}
                    helperText={
                      tSStart > tSEnd
                        ? "Start Date should not be later than End Date"
                        : null
                    }
                  />
                  &nbsp;&nbsp;&nbsp;
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="dd/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="End Date"
                    value={tSEnd}
                    onChange={handleTimeStampEnd}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSStart > tSEnd ? true : false}
                    helperText={
                      tSStart > tSEnd
                        ? "End Date should not be earlier than Start Date"
                        : null
                    }
                  />
                </Grid>
                <div>&nbsp;</div>
              </MuiPickersUtilsProvider>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Alarm Clear TimeStamp
                  </span>
                </Grid>
              </Grid>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justifyContent="space-around">
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="dd/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="Start Date"
                    value={tSClearStart}
                    onChange={handleClearTimeStampStart}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSClearStart > tSClearEnd ? true : false}
                    helperText={
                      tSClearStart > tSClearEnd
                        ? "Start Date should not be later than End Date"
                        : null
                    }
                  />
                  &nbsp;&nbsp;&nbsp;
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="dd/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="End Date"
                    value={tSClearEnd}
                    onChange={handleClearTimeStampEnd}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSClearStart > tSClearEnd ? true : false}
                    helperText={
                      tSClearStart > tSClearEnd
                        ? "End Date should not be earlier than Start Date"
                        : null
                    }
                  />
                </Grid>
                <div>&nbsp;</div>
              </MuiPickersUtilsProvider>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Duration for Alarm Deactivation
                  </span>
                </Grid>
              </Grid>
              <div>&nbsp;</div>

              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em" }}>Clear duration is</span>
                  &nbsp;&nbsp;&nbsp;
                  <FormControl className={classes.formControl}>
                    {/* <InputLabel id='demo-simple-select-label'>Age</InputLabel> */}
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={withinOrExceed}
                      onChange={handleWithinOrExceed}
                    >
                      <MenuItem value={"Within"}>Within</MenuItem>
                      <MenuItem value={"Exceed"}>Exceed</MenuItem>
                    </Select>
                  </FormControl>
                  &nbsp; &nbsp; &nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "10ch" }}
                    onChange={handleSetDurationDays}
                    value={durationDays}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">Day</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                  &nbsp; &nbsp; &nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "10ch" }}
                    onChange={handleSetDurationHours}
                    value={durationHours}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      inputProps: {
                        max: 24,
                        min: -1,
                      },
                      endAdornment: (
                        <InputAdornment position="start">Hrs</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                  &nbsp; &nbsp; &nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "10ch" }}
                    onChange={handleSetDurationMinutes}
                    value={durationMinutes}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      inputProps: {
                        max: 60,
                        min: -1,
                      },
                      endAdornment: (
                        <InputAdornment position="start">Min</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Equipment ID
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl
                    style={{ minWidth: 120 }}
                    className={classes.formControl}
                  >
                    <InputLabel id="demo-mutiple-chip-label">
                      Equipment ID
                    </InputLabel>
                    <Select
                      labelId="demo-mutiple-chip-label"
                      id="demo-mutiple-chip"
                      multiple
                      value={EquipmentIDs}
                      onChange={handleMultipleEquipmentID}
                      input={<Input id="select-multiple-chip" />}
                      renderValue={(selected) => (
                        <div>
                          {selected.map((value) => (
                            <Chip key={value} label={value} />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                    >
                      {equipmentIDs.map((ids) => (
                        <MenuItem
                          key={ids}
                          value={ids}
                          style={getStyles(ids, EquipmentIDs, theme)}
                        >
                          {ids}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Alarm Types
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl
                    style={{ minWidth: 120 }}
                    className={classes.formControl}
                  >
                    <InputLabel id="demo-mutiple-chip-label">
                      Alarm Types
                    </InputLabel>
                    <Select
                      labelId="demo-mutiple-chip-label"
                      id="demo-mutiple-chip"
                      multiple
                      value={alarmTypes}
                      onChange={handleMultipleAlarmTypes}
                      input={<Input id="select-multiple-chip" />}
                      renderValue={(selected) => (
                        <div>
                          {selected.map((value) => (
                            <Chip key={value} label={value} />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                    >
                      {alarmList.map((alarms) => (
                        <MenuItem
                          key={alarms}
                          value={alarms}
                          style={getStyles(alarms, alarmTypes, theme)}
                        >
                          {alarms}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Apply
              </Button>
              <Button onClick={handleClear} color="primary">
                Clear
              </Button>
            </DialogActions>
          </Dialog>
        );
      }

      if (dataType === "Other") {
        body = (
          <Dialog
            fullWidth
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">
              Advance Filtering Options
            </DialogTitle>

            <DialogContent>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    TimeStamp
                  </span>
                </Grid>
              </Grid>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justifyContent="space-around">
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="dd/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="Start Date"
                    value={tSStart}
                    onChange={handleTimeStampStart}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSStart > tSEnd ? true : false}
                    helperText={
                      tSStart > tSEnd
                        ? "Start Date should not be later than End Date"
                        : null
                    }
                  />
                  &nbsp;&nbsp;&nbsp;
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="dd/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="End Date"
                    value={tSEnd}
                    onChange={handleTimeStampEnd}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSStart > tSEnd ? true : false}
                    helperText={
                      tSStart > tSEnd
                        ? "End Date should not be earlier than Start Date"
                        : null
                    }
                  />
                </Grid>
              </MuiPickersUtilsProvider>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Equipment ID
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl
                    style={{ minWidth: 120 }}
                    className={classes.formControl}
                  >
                    <InputLabel id="demo-mutiple-chip-label">
                      Equipment ID
                    </InputLabel>
                    <Select
                      labelId="demo-mutiple-chip-label"
                      id="demo-mutiple-chip"
                      multiple
                      value={EquipmentIDs}
                      onChange={handleMultipleEquipmentID}
                      input={<Input id="select-multiple-chip" />}
                      renderValue={(selected) => (
                        <div>
                          {selected.map((value) => (
                            <Chip key={value} label={value} />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                    >
                      {equipmentIDs.map((ids) => (
                        <MenuItem
                          key={ids}
                          value={ids}
                          style={getStyles(ids, EquipmentIDs, theme)}
                        >
                          {ids}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Apply
              </Button>
              <Button onClick={handleClear} color="primary">
                Clear
              </Button>
            </DialogActions>
          </Dialog>
        );
      }

      break;
    case "zenith":
      if (dataType === "Alarm") {
        let arr = [];
        for (let i = 0; i < 8; i++) {
          arr.push(i);
        }

        let menuItemDays = arr.map((day) => {
          return <MenuItem value={day}>{day}</MenuItem>;
        });

        arr = [];
        for (let i = 0; i < 24; i++) {
          arr.push(i);
        }

        let menuItemHours = arr.map((hour) => {
          return <MenuItem value={hour}>{hour}</MenuItem>;
        });

        arr = [];

        for (let i = 0; i < 60; i++) {
          arr.push(i);
        }

        let menuItemMinutes = arr.map((minutes) => {
          return <MenuItem value={minutes}>{minutes}</MenuItem>;
        });

        body = (
          <Dialog
            fullWidth
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">
              Advance Filtering Options
            </DialogTitle>

            <DialogContent>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Alarm Trigger TimeStamp
                  </span>
                </Grid>
              </Grid>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justifyContent="space-around">
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="Start Date"
                    value={tSStart}
                    onChange={handleTimeStampStart}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSStart > tSEnd ? true : false}
                    helperText={
                      tSStart > tSEnd
                        ? "Start Date should not be later than End Date"
                        : null
                    }
                  />
                  &nbsp;&nbsp;&nbsp;
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="End Date"
                    value={tSEnd}
                    onChange={handleTimeStampEnd}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSStart > tSEnd ? true : false}
                    helperText={
                      tSStart > tSEnd
                        ? "End Date should not be earlier than Start Date"
                        : null
                    }
                  />
                </Grid>
                <div>&nbsp;</div>
              </MuiPickersUtilsProvider>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Alarm Clear TimeStamp
                  </span>
                </Grid>
              </Grid>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justifyContent="space-around">
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="Start Date"
                    value={tSClearStart}
                    onChange={handleClearTimeStampStart}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSClearStart > tSClearEnd ? true : false}
                    helperText={
                      tSClearStart > tSClearEnd
                        ? "Start Date should not be later than End Date"
                        : null
                    }
                  />
                  &nbsp;&nbsp;&nbsp;
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="End Date"
                    value={tSClearEnd}
                    onChange={handleClearTimeStampEnd}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSClearStart > tSClearEnd ? true : false}
                    helperText={
                      tSClearStart > tSClearEnd
                        ? "End Date should not be earlier than Start Date"
                        : null
                    }
                  />
                </Grid>
                <div>&nbsp;</div>
              </MuiPickersUtilsProvider>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Duration for Alarm Deactivation
                  </span>
                </Grid>
              </Grid>
              <div>&nbsp;</div>

              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em" }}>Clear duration is</span>
                  &nbsp;&nbsp;&nbsp;
                  <FormControl className={classes.formControl}>
                    {/* <InputLabel id='demo-simple-select-label'>Age</InputLabel> */}
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={withinOrExceed}
                      onChange={handleWithinOrExceed}
                    >
                      <MenuItem value={"Within"}>Within</MenuItem>
                      <MenuItem value={"Exceed"}>Exceed</MenuItem>
                    </Select>
                  </FormControl>
                  &nbsp; &nbsp; &nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "10ch" }}
                    onChange={handleSetDurationDays}
                    value={durationDays}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">Day</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                  &nbsp; &nbsp; &nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "10ch" }}
                    onChange={handleSetDurationHours}
                    value={durationHours}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      inputProps: {
                        max: 24,
                        min: -1,
                      },
                      endAdornment: (
                        <InputAdornment position="start">Hrs</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                  &nbsp; &nbsp; &nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "10ch" }}
                    onChange={handleSetDurationMinutes}
                    value={durationMinutes}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      inputProps: {
                        max: 60,
                        min: -1,
                      },
                      endAdornment: (
                        <InputAdornment position="start">Min</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Equipment Groups
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl style={{ minWidth: 180 }}>
                    <InputLabel id="demo-simple-select-label">
                      Equipment Groups
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={equipmentGroup}
                      onChange={handleEquipmentGroups}
                    >
                      <MenuItem value={null}>None</MenuItem>
                      <MenuItem value={"DD"}>DD</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Equipment ID
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl
                    style={{ minWidth: 120 }}
                    className={classes.formControl}
                  >
                    <InputLabel id="demo-mutiple-chip-label">
                      Equipment ID
                    </InputLabel>
                    <Select
                      labelId="demo-mutiple-chip-label"
                      id="demo-mutiple-chip"
                      multiple
                      value={EquipmentIDs}
                      onChange={handleMultipleEquipmentID}
                      input={<Input id="select-multiple-chip" />}
                      renderValue={(selected) => (
                        <div>
                          {selected.map((value) => (
                            <Chip key={value} label={value} />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                    >
                      {equipmentIDs.map((ids) => (
                        <MenuItem
                          key={ids}
                          value={ids}
                          style={getStyles(ids, EquipmentIDs, theme)}
                        >
                          {ids}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Alarm Types
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl
                    style={{ minWidth: 120 }}
                    className={classes.formControl}
                  >
                    <InputLabel id="demo-mutiple-chip-label">
                      Alarm Types
                    </InputLabel>
                    <Select
                      labelId="demo-mutiple-chip-label"
                      id="demo-mutiple-chip"
                      multiple
                      value={alarmTypes}
                      onChange={handleMultipleAlarmTypes}
                      input={<Input id="select-multiple-chip" />}
                      renderValue={(selected) => (
                        <div>
                          {selected.map((value) => (
                            <Chip key={value} label={value} />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                    >
                      {alarmList.map((alarms) => (
                        <MenuItem
                          key={alarms}
                          value={alarms}
                          style={getStyles(alarms, alarmTypes, theme)}
                        >
                          {alarms}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Apply
              </Button>
              <Button onClick={handleClear} color="primary">
                Clear
              </Button>
            </DialogActions>
          </Dialog>
        );
      }

      if (dataType === "Weight") {
        body = (
          <Dialog
            fullWidth
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">
              Advance Filtering Options
            </DialogTitle>

            <DialogContent>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Weight Discharge Time
                  </span>
                </Grid>
              </Grid>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justifyContent="space-around">
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="Start Date"
                    value={tSStart}
                    onChange={handleTimeStampStart}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSStart > tSEnd ? true : false}
                    helperText={
                      tSStart > tSEnd
                        ? "Start Date should not be later than End Date"
                        : null
                    }
                  />
                  &nbsp;&nbsp;&nbsp;
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="End Date"
                    value={tSEnd}
                    onChange={handleTimeStampEnd}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    error={tSStart > tSEnd ? true : false}
                    helperText={
                      tSStart > tSEnd
                        ? "End Date should not be earlier than Start Date"
                        : null
                    }
                  />
                </Grid>
                <div>&nbsp;</div>
              </MuiPickersUtilsProvider>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Equipment Groups
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl style={{ minWidth: 180 }}>
                    <InputLabel id="demo-simple-select-label">
                      Equipment Groups
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={equipmentGroup}
                      onChange={handleEquipmentGroups}
                    >
                      <MenuItem value={null}>None</MenuItem>
                      <MenuItem value={"DD"}>DD</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", color: "white" }}>
                    Equipment ID
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <FormControl
                    style={{ minWidth: 120 }}
                    className={classes.formControl}
                  >
                    <InputLabel id="demo-mutiple-chip-label">
                      Equipment ID
                    </InputLabel>
                    <Select
                      labelId="demo-mutiple-chip-label"
                      id="demo-mutiple-chip"
                      multiple
                      value={EquipmentIDs}
                      onChange={handleMultipleEquipmentID}
                      input={<Input id="select-multiple-chip" />}
                      renderValue={(selected) => (
                        <div>
                          {selected.map((value) => (
                            <Chip key={value} label={value} />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                    >
                      {equipmentIDs.map((ids) => (
                        <MenuItem
                          key={ids}
                          value={ids}
                          style={getStyles(ids, EquipmentIDs, theme)}
                        >
                          {ids}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <div>&nbsp;</div>

              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    backgroundColor: "#26477c",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em" }}>Discharge Weight</span>
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", marginTop: "0.4em" }}>
                    Discharge Weight is
                  </span>
                  &nbsp;&nbsp; &nbsp;&nbsp;
                  <FormControl className={classes.formControl}>
                    {/* <InputLabel id='demo-simple-select-label'>Age</InputLabel> */}
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={weightLimit.discharge}
                      onChange={handleDischargeWeightLimit}
                    >
                      <MenuItem value={"="}>{"equals"}</MenuItem>
                      <MenuItem value={"!="}>{"not equals"}</MenuItem>
                      <MenuItem value={">"}>{"exceeds"}</MenuItem>
                      <MenuItem value={">="}>{"exceeds and equals"}</MenuItem>
                      <MenuItem value={"<"}>{"less than"}</MenuItem>
                      <MenuItem value={"<="}>{"less than or equals"}</MenuItem>
                    </Select>
                  </FormControl>
                  &nbsp;&nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "12ch" }}
                    onChange={handleDischargeWeight}
                    value={weightDischarged}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">Kg</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                </Grid>
              </Grid>
              <div>&nbsp;</div>
              <Grid container spacing={1}>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                  item
                  xs={12}
                >
                  <span style={{ fontSize: "1.2em", marginTop: "0.4em" }}>
                    Balanced Weight is
                  </span>
                  &nbsp;&nbsp; &nbsp;&nbsp;
                  <FormControl className={classes.formControl}>
                    {/* <InputLabel id='demo-simple-select-label'>Age</InputLabel> */}
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={weightLimit.balance}
                      onChange={handleBalanceWeightLimit}
                    >
                      <MenuItem value={"="}>{"equals"}</MenuItem>
                      <MenuItem value={"!="}>{"not equals"}</MenuItem>
                      <MenuItem value={">"}>{"exceeds"}</MenuItem>
                      <MenuItem value={">="}>{"exceeds and equals"}</MenuItem>
                      <MenuItem value={"<"}>{"less than"}</MenuItem>
                      <MenuItem value={"<="}>{"less than or equals"}</MenuItem>
                    </Select>
                  </FormControl>
                  &nbsp;&nbsp;
                  <TextField
                    // label='Days'
                    id="standard-adornment-weight"
                    style={{ width: "12ch" }}
                    onChange={handleBalanceWeight}
                    value={balancedWeight}
                    type={"number"}
                    className={clsx(classes.margin, classes.textField)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">Kg</InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Apply
              </Button>
              <Button onClick={handleClear} color="primary">
                Clear
              </Button>
            </DialogActions>
          </Dialog>
        );
      }

      break;
    default:
    // code block
  }

  // return { body };
  return (
    <div>
      <span
        onClick={handleClickOpen}
        // onMouseLeave={handleDropDownClose}
        style={{
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          color: "#26477c",
        }}
      >
        <HorizontalSplitIcon fontSize={"small"} />
        &nbsp; &nbsp;
        <span
          style={{
            fontFamily: "Roboto",
            fontWeight: "500",
            fontSize: "0.8125rem",
            color: "#26477c",
          }}
        >
          ADV FILTERS
        </span>
      </span>
      {body}
    </div>
  );
}
